/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module VsLogsModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { signpostsWithRange, templatesConfiguration } from 'ng/modules/vs-logs/constants/vs-logs-signpost.constants';

import {
    IVsLogsSignpostTemplateConfig,
    IVsLogsSignpostUpdatableParams,
} from 'ng/modules/vs-logs/vs-logs.types';

import { getRequestParams, getRLengthRequestParams } from 'ng/modules/vs-logs/utils/vs-logs-signpost.utils';
import { VsLogsSignpostStore } from '../vs-logs-signpost.store';
import './vs-logs-signpost-default.component.less';

/**
 * @description
 *     Component for displaying default singpost template.
 * @author Suraj Kumar
 */
@Component({
    selector: 'vs-logs-signpost-default',
    templateUrl: './vs-logs-signpost-default.component.html',
})
export class VsLogsSignpostDefaultComponent implements OnInit {
    /**
     * Selected signpost config key.
     */
    @Input()
    public configKey: string;

    /**
     * Selected signpost respective configuration in templatesConfiguration.
     */
    public activeTemplateConfig: IVsLogsSignpostTemplateConfig;

    constructor(public readonly vsLogsSignpostStore: VsLogsSignpostStore) {}

    /** @override */
    public ngOnInit(): void {
        this.activeTemplateConfig = templatesConfiguration[this.configKey];

        this.fetchSignpostData();
    }

    private fetchSignpostData(): void {
        let fullSignpostParams: IVsLogsSignpostUpdatableParams = getRequestParams(this.activeTemplateConfig);

        if (signpostsWithRange.has(this.configKey)) {
            fullSignpostParams = getRLengthRequestParams(fullSignpostParams, this.activeTemplateConfig, this.configKey);
        }

        this.vsLogsSignpostStore.getVsLogSignpostData(fullSignpostParams);
    }
}
